import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ProfileApi, type GetProfile } from '@shared/api';

interface ProfileType {
  data: GetProfile | null;
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useProfileStore = create<ProfileType>((set) => ({
  data: null,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProfileApi.getProfile(signal);
      set({ data: result ?? undefined, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
